import React from "react"
import {
  Order,
  OrderAddress,
  OrderPayment,
  OrderPaymentAdyen,
  OrderPaymentAvarda,
  OrderPaymentBrinkZeroPayment,
  OrderPaymentKlarnaCheckout,
  OrderPaymentLedyer,
  OrderPaymentQliroOne,
  OrderPaymentSveaCheckout,
  OrderPaymentWalleyCheckout,
  OrderPaymentZaver
} from "lib/types/generated/graphql-types"

import OrderBlock from "components/Order/OrderBlock"
import Adyen from "./Adyen"
import Kustom from "./Kustom"
import Svea from "./Svea"
import QliroOne from "./QliroOne"
import Walley from "./Walley"
import BrinkZeroPayment from "./BrinkZeroPayment"
import Avarda from "./Avarda"
import Zaver from "./Zaver"
import Ledyer from "./Ledyer"
import Address from "../../../../../components/Order/Address/Address"
import { AddressType } from "lib/types/order"
import { Columns } from "../OrderDetails.styled"
import Vat from "./Vat"

type Props = {
  orderPayment:
    | OrderPaymentAdyen
    | OrderPaymentKlarnaCheckout
    | OrderPaymentSveaCheckout
    | OrderPaymentQliroOne
    | OrderPaymentBrinkZeroPayment
  billingAddress: OrderAddress
  order: Order
  refetch: () => void
  refetchLoading: boolean
}

function isOrderPaymentAdyen(object: OrderPayment): object is OrderPaymentAdyen {
  return object.providerName === "Adyen"
}

function isOrderPaymentKlarnaCheckout(object: OrderPayment): object is OrderPaymentKlarnaCheckout {
  return object.providerName === "KlarnaCheckout"
}

function isOrderPaymentSveaCheckout(object: OrderPayment): object is OrderPaymentSveaCheckout {
  return object.providerName === "SveaCheckout"
}

function isOrderPaymentWalleyCheckout(object: OrderPayment): object is OrderPaymentWalleyCheckout {
  return object.providerName === "WalleyCheckout"
}

function isOrderPaymentQliroOne(object: OrderPayment): object is OrderPaymentQliroOne {
  return object.providerName === "QliroOne"
}

function isOrderPaymentBrinkZero(object: OrderPayment): object is OrderPaymentBrinkZeroPayment {
  return object.providerName === "BrinkZeroPayment"
}

function isOrderPaymentAvarda(object: OrderPayment): object is OrderPaymentAvarda {
  return object.providerName === "Avarda"
}

function isOrderPaymentZaver(object: OrderPayment): object is OrderPaymentZaver {
  return object.providerName === "Zaver"
}

function isOrderPaymentLedyer(object: OrderPayment): object is OrderPaymentLedyer {
  return object.providerName === "Ledyer"
}

const OrderPaymentInfo = ({
  orderPayment,
  billingAddress,
  order,
  refetch,
  refetchLoading
}: Props) => {
  return (
    <Columns>
      <Address
        addressType={AddressType.BILLING_ADDRESS}
        address={billingAddress}
        order={order}
        refetch={refetch}
        refetchLoading={refetchLoading}
      />
      <OrderBlock>
        <>
          {isOrderPaymentAdyen(orderPayment) && <Adyen orderPayment={orderPayment} />}
          {isOrderPaymentKlarnaCheckout(orderPayment) && <Kustom orderPayment={orderPayment} />}
          {isOrderPaymentSveaCheckout(orderPayment) && <Svea orderPayment={orderPayment} />}
          {isOrderPaymentWalleyCheckout(orderPayment) && <Walley orderPayment={orderPayment} />}
          {isOrderPaymentQliroOne(orderPayment) && <QliroOne orderPayment={orderPayment} />}
          {isOrderPaymentBrinkZero(orderPayment) && (
            <BrinkZeroPayment orderPayment={orderPayment} />
          )}
          {isOrderPaymentAvarda(orderPayment) && <Avarda orderPayment={orderPayment} />}
          {isOrderPaymentZaver(orderPayment) && <Zaver orderPayment={orderPayment} />}
          {isOrderPaymentLedyer(orderPayment) && <Ledyer orderPayment={orderPayment} />}
        </>
        <Vat order={order}/>
      </OrderBlock>
    </Columns>
  )
}

export default OrderPaymentInfo
